import { useQueryId, useSharableSeriesId } from '@/hooks';
import { UUID } from '@/types';
import DataTable from '@/util/DataTable';
import { buildDataTable } from '@/reducers/rows';
import { useAppSelector } from '@/store/hooks';
import { getDataTable, getRowsLoading } from '@/store-selectors';
import { useLoadRows } from '..';

export const useLoadRows_LEGACY = (skip = false) => {
  const queryId = useQueryId();
  const sharableSeriesId = useSharableSeriesId();
  const { data, ...rest } = useLoadRows(skip || !!sharableSeriesId);
  const isSharableDataTableLoading = useAppSelector(getRowsLoading);
  const sharableDataTable = useAppSelector(getDataTable);

  let state: {
    queryId: Maybe<UUID>;
    dataTable: Maybe<DataTable>;
    rowCount: Maybe<number>;
    page: number;
    isLoading?: boolean;
    isFetching?: boolean;
  } = {
    queryId,
    dataTable: null,
    rowCount: null,
    page: 1,
  };

  if (data) {
    state = {
      ...state,
      dataTable: buildDataTable(data.dataTable),
      rowCount: data.dataTable._rows.length,
      page: data.page,
      queryId: data.queryId,
    };
  } else if (sharableSeriesId) {
    state = {
      ...state,
      dataTable: sharableDataTable,
      isLoading: isSharableDataTableLoading,
      isFetching: isSharableDataTableLoading,
    };

    return state;
  }

  return { ...state, ...rest } as const;
};
